import React from "react";
import { SiYoutube, SiTelegram, SiX, SiInstagram, SiFacebook, SiDiscord, SiTiktok, SiReddit, SiWhatsapp } from "react-icons/si";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaGlobe } from "react-icons/fa6";

type IconComponent = React.FC<{ className?: string }>;

export interface SocialIconConfig {
  icon: IconComponent;
  color: string;
}

const iconMap: Record<string, SocialIconConfig> = {
  youtube:   { icon: SiYoutube as IconComponent,   color: "bg-[#FF0000]/15 text-[#FF0000]" },
  telegram:  { icon: SiTelegram as IconComponent,  color: "bg-[#229ED9]/15 text-[#229ED9]" },
  x:         { icon: SiX as IconComponent,         color: "bg-foreground text-background" },
  twitter:   { icon: SiX as IconComponent,         color: "bg-foreground text-background" },
  instagram: { icon: SiInstagram as IconComponent, color: "bg-[#E4405F]/15 text-[#E4405F]" },
  facebook:  { icon: SiFacebook as IconComponent,  color: "bg-[#1877F2]/15 text-[#1877F2]" },
  discord:   { icon: SiDiscord as IconComponent,   color: "bg-[#5865F2]/15 text-[#5865F2]" },
  tiktok:    { icon: SiTiktok as IconComponent,    color: "bg-foreground/10 text-foreground" },
  reddit:    { icon: SiReddit as IconComponent,    color: "bg-[#FF4500]/15 text-[#FF4500]" },
  linkedin:  { icon: FaLinkedinIn as IconComponent,  color: "bg-[#0A66C2]/15 text-[#0A66C2]" },
  whatsapp:  { icon: SiWhatsapp as IconComponent,  color: "bg-[#25D366]/15 text-[#25D366]" },
};

const aliasMap: Record<string, string> = {
  send: "telegram",
  tg: "telegram",
  "paper-plane": "telegram",
  paperplane: "telegram",
  twitter: "x",
  tw: "x",
  ig: "instagram",
  insta: "instagram",
  fb: "facebook",
  meta: "facebook",
  yt: "youtube",
  wa: "whatsapp",
  in: "linkedin",
  li: "linkedin",
};

function resolveKey(raw?: string): string {
  if (!raw) return "";
  const k = raw.toLowerCase().trim();
  return aliasMap[k] || k;
}

export function getSocialIcon(iconKey: string, platform?: string): SocialIconConfig {
  const fromKey = iconMap[resolveKey(iconKey)];
  if (fromKey) return fromKey;
  const fromPlatform = iconMap[resolveKey(platform)];
  if (fromPlatform) return fromPlatform;
  return { icon: FaGlobe as IconComponent, color: "bg-muted text-muted-foreground" };
}

export const PLATFORM_PRESETS = [
  { value: "youtube",   label: "YouTube",      iconKey: "youtube" },
  { value: "telegram",  label: "Telegram",     iconKey: "telegram" },
  { value: "x",         label: "X (Twitter)",  iconKey: "x" },
  { value: "instagram", label: "Instagram",    iconKey: "instagram" },
  { value: "facebook",  label: "Facebook",     iconKey: "facebook" },
  { value: "discord",   label: "Discord",      iconKey: "discord" },
  { value: "tiktok",    label: "TikTok",       iconKey: "tiktok" },
  { value: "reddit",    label: "Reddit",       iconKey: "reddit" },
  { value: "linkedin",  label: "LinkedIn",     iconKey: "linkedin" },
  { value: "whatsapp",  label: "WhatsApp",     iconKey: "whatsapp" },
  { value: "other",     label: "Other",        iconKey: "other" },
];
